import toJS from 'immutable-less/transmute/toJS';
export const toJSTyped = toJS;